<template>
  <div
    class="header-wrapper"
    :class="{
      '-scroll-down': scrollDirection === 'down',
      '-scroll-top': scrollDirection === 'top',
      '-scroll-up': scrollDirection === 'up',
      '-menu-open': menuOpen,
      '-menu-section-open': isMenuSectionOpened
    }"
    ref="headerWrapper"
    :style="{
      top: `${headerTranslateY}px`,
      '--zenith-header-height': `${currentHeaderHeight}px`
    }"
  >
    <geo-popup
      @geoOpened="adjustHeaderPosition"
      @geoClosed="adjustHeaderPosition"
    />
    <TopMessage
      ref="topMessage"
      class-name="top-message"
      @topMessageOpened="adjustHeaderPosition"
      @topMessageClosed="adjustHeaderPosition"
      v-if="
        $route.name !== 'page-not-found' &&
          $route.meta &&
          $route.meta.pageType !== 'ChronomasterSport'
      "
    />
    <header
      id="header-site"
      ref="header"
      class="header container-fluid -global mt-4"
      :class="{
        '-open': isMenuSectionOpened,
        '-scroll-down': scrollDirection === 'down',
        '-scroll-top': scrollDirection === 'top',
        '-scroll-up': scrollDirection === 'up',
      }"
      v-click-outside="clickOutside"
      @touchmove.stop
    >
      <span class="a11y-sr-only">
        Header
      </span>
      <div v-show="isMenuSectionOpened" @click="closeMenu" class="header-background"></div>
      <div ref="navigationRow" class="row align-items-center align-content-start justify-content-between">
        <div class="col-2 p-0" v-if="isMobile">
          <Burger v-if="$route.name !== 'page-not-found'" />
        </div>
        <!-- <DarkModeButton></DarkModeButton> -->
        <transition name="fade">
          <router-link
            :to="`${localizedUrl}`"
            class="logo d-flex justify-content-center col col-md-auto"
            ref="logo"
            key="1"
            :title="$t('Logo Zenith Watches, to home page')"
            @click.native="$emit('close')"
          >
            <template v-if="route === 'home'">
              <!-- SEO -->
              <h1>
                <img
                  :src="logoUrl"
                  class="-white"
                  :alt="$t('Logo Zenith Watches, to home page')"
                  width="120px"
                  height="45px"
                />
              </h1>
            </template>
            <template v-else>
              <img
                :src="logoUrl"
                class="-white"
                :alt="$t('Logo Zenith Watches, to home page')"
                width="120px"
                height="45px"
              />
            </template>
          </router-link>
        </transition>
        <ul v-if="isMobile" class="utils col-2 d-flex justify-content-end">
          <li v-show="ecommerceActivated">
            <router-link
              :aria-label="$t('Shopping cart')"
              :to="`${localizedUrl}/cart`"
              class="utils-button"
            >
              <i class="icon-cart"></i>
            </router-link>
            <counter
              :value="itemsInCart"
              :active="itemsInCart"
              :trad="$t('Product in cart')"
            ></counter>
          </li>
          <li v-if="accountActivated || isQRStore">
            <router-link
              :aria-label="$t('My profile')"
              class="utils-button"
              :to="
                isLoggedIn
                  ? `${localizedUrl}/my-profile`
                  : `${localizedUrl}/login`
              "
            >
              <i class="icon-account"></i>
            </router-link>
            <LoginTooltip :menu-open="menuOpen" />
          </li>
        </ul>
        <template v-if="searchOpen || isMobile || route === 'search'">
          <Search
            :aria="(menuOpen && isMobile) || route === 'search'"
            :collections="nav.watches.collections"
            :link-label="nav.watches.linkLabel"
            @close="closeSearch"
          ></Search>
        </template>
        <nav id="navigation" class="navigation mx-auto col-md d-md-flex align-items-center justify-content-center">
          <div
            class="menu_selector"
            ref="selector"
            :class="{ '-active': menuActive || menuHover }"
          ></div>
          <ul class="menu" ref="menu" aria-label="Main menu">
            <li :class="{'d-none': !(isLogo160Online && logo160Url)}">
              <router-link
                :to="localizedUrl + nav.anniversary.link"
                class="link -small link-160 d-flex align-items-center justify-content-lg-center"
                :aria-current="menuActive === 0"
                :tabindex="isMobile && !menuOpen ? -1 : 0"
              >
                <img
                  v-if="isLogo160Online && logo160Url"
                  :src="logo160Url"
                  class="-white img-160"
                  :alt="$t('Zenith 160th logo')"
                  width="120px"
                  height="45px"
                />
                <p class="-upper d-md-none ml-4 pl-2 mb-0" v-html="$t('160<sup>th</sup> anniversary')"></p>
              </router-link>
            </li>
            <!-- <li>
            <router-link
              :to="`${localizedUrl}/our-selection/new-models`"
              class="link -small"
              :aria-current="menuActive === 1"
              :tabindex="isMobile && !menuOpen ? -1 : 0"
            >
              <span ref="menu4" v-html="$t(nav.menu[0])"></span>
            </router-link>
          </li> -->
            <!-- Watches -->
            <li
              aria-haspopup="true"
              :aria-expanded="
                menuOpen && menuSection === 'watches' ? 'true' : 'false'
              "
            >
              <button
                type="button"
                class="link -small"
                @click="toggleMenu('watches'), callGTM({
                  event: 'menuClick',
                  menuLevel1: nav.menu[1],
                  menuLevel2: ''
                })"
                id="btn-menu-watches"
                aria-controls="menu-watches"
                :tabindex="isMobile && !menuOpen ? -1 : 0"
                :aria-current="menuActive === 2"
                :aria-expanded="
                  menuOpen && menuSection === 'watches' ? 'true' : 'false'
                "
              >
                <p class="navigation-title h2" ref="menu2" v-text="$t(nav.menu[1])"></p>
                <span class="icon-arrow-right d-md-none" aria-hidden="true"></span>
              </button>
              <transition name="fade">
                <div
                  class="menu_rich"
                  id="menu-watches"
                  aria-labelledby="btn-menu-watches"
                  v-show="menuOpen && menuSection === 'watches'"
                  :class="{ '-open': menuOpen && menuSection === 'watches' }"
                >
                  <button
                    class="back d-flex d-md-none align-items-center"
                    type="button"
                    @click.stop.prevent="openMenu"
                  >
                    <undo-icon />
                    <span class="font-bold ml-4 pl-2" v-text="$t(nav.menu[1])"></span>
                  </button>
                  <div class="container -watches">
                    <div class="row submenu-wrapper">
                      <aside-links
                        v-if="!isMobile"
                        class="col-lg-3"
                        :external-menu-label="nav.menu[1]"
                        :preview-label="$t(nav.watches.previewLabel)"
                        :aside-list="nav.watches"
                      ></aside-links>
                      <collections-group
                        class="col-12 col-lg-9"
                        :section-links="getSectionLinks('watches')"
                        :collections-group="nav.watches"
                        :is-server="isSSR"
                        :external-menu-label="nav.menu[1]"
                        :collection-class-name="'-watches'"
                      >
                      </collections-group>
                      <aside-links
                        class="col-12"
                        v-if="isMobile"
                        :external-menu-label="nav.menu[1]"
                        :preview-label="$t(nav.watches.previewLabel)"
                        :aside-list="nav.watches"
                      ></aside-links>
                    </div>
                  </div>
                </div>
              </transition>
            </li>
            <!-- Straps -->
            <li
              v-if="strapActivated"
              aria-haspopup="true"
              :aria-expanded="
                menuOpen && menuSection === 'straps' ? 'true' : 'false'
              "
            >
              <router-link
                :to="`${localizedUrl}/products/straps`"
                class="link -small"
                @click.native="callGTM({
                  event: 'menuClick',
                  menuLevel1: nav.menu[5],
                  menuLevel2: ''
                })"
                :aria-current="menuActive === 5"
                :tabindex="isMobile && !menuOpen ? -1 : 0"
              >
                <p class="navigation-title h2" ref="menu2" v-text="$t(nav.menu[5])"></p>
              </router-link>
              <!-- button
              type="button"
              class="link -small"
              @keyup.space="openMenu('straps')"
              id="btn-menu-straps"
              aria-controls="menu-straps"
              :tabindex="isMobile && !menuOpen ? -1 : 0"
              :aria-current="menuActive === 5"
              :aria-expanded="menuOpen && menuSection === 'straps' ? 'true' : 'false'"
            >
              <span ref="menu2" v-html="$t(nav.menu[5])"></span>
            </button>
            <transition name="fade">
              <div class="menu_rich" id="menu-straps" aria-labelledby="btn-menu-straps" v-show="menuOpen && menuSection === 'straps'" :class="{ '-open': menuOpen && menuSection === 'straps' }">
                <button class="back" type="button" @click.stop.prevent="openMenu" v-html="$t(nav.menu[5])"></button>
                <div class="container -straps" v-bsl="isMobile && menuOpen && menuSection === 'straps'">
                  <div class="row">
                    <div class="col-12 col-md-8" v-if="bannerStrapPicture">
                      <router-link class="banner" :to="`${localizedUrl}/${nav.straps.cta.link}`" @click.native="$emit('close')">
                        <strong v-text="$t(nav.straps.cta.title)"></strong>
                        <NoSSR>
                          <lazy-image :item="bannerStrapPicture" :sizes="bannerStrapPictureSizes" rootMargin="0px"></lazy-image>
                        </NoSSR>
                      </router-link>
                    </div>
                    <div class="col-12 col-md-3 offset-md-1 aside straps">
                      <strong class="title" v-html="$t(nav.straps.title)"></strong>
                      <p class="text" v-html="$t(nav.straps.text)"></p>
                    </div>
                  </div>
                </div>
              </div>
            </transition -->
            </li>
            <!-- La Maison -->
            <li
              aria-haspopup="true"
              :aria-expanded="
                menuOpen && menuSection === 'brand' ? 'true' : 'false'
              "
            >
              <button
                type="button"
                class="link -small"
                @click="toggleMenu('brand'), callGTM({
                  event: 'menuClick',
                  menuLevel1: nav.menu[2],
                  menuLevel2: ''
                })"
                id="btn-menu-brand"
                aria-controls="menu-brand"
                :tabindex="isMobile && !menuOpen ? -1 : 0"
                :aria-current="menuActive === 3"
                :aria-expanded="
                  menuOpen && menuSection === 'brand' ? 'true' : 'false'
                "
              >
                <p class="navigation-title h2" ref="menu3" v-text="$t(nav.menu[2])"></p>
                <span class="icon-arrow-right d-md-none" aria-hidden="true"></span>
              </button>
              <transition name="fade">
                <div
                  class="menu_rich"
                  id="menu-brand"
                  aria-labelledby="btn-menu-brand"
                  v-show="menuOpen && menuSection === 'brand'"
                  :class="{ '-open': menuOpen && menuSection === 'brand' }"
                >
                  <button
                    class="back d-flex d-md-none align-items-center"
                    type="button"
                    @click.stop.prevent="openMenu"
                  >
                    <undo-icon />
                    <span class="font-bold ml-4 pl-2" v-text="$t(nav.menu[2])"></span>
                  </button>
                  <div class="container">
                    <div class="row submenu-wrapper">
                      <aside-links
                        v-if="!isMobile"
                        class="col-lg-3"
                        :external-menu-label="nav.menu[2]"
                        :preview-label="$t(nav.menu[2])"
                        :aside-list="nav.brand"
                      ></aside-links>
                      <collections-group
                        class="col-12 col-lg-9"
                        :section-links="getSectionLinks('brand')"
                        :collections-group="nav.brand"
                        :is-server="isSSR"
                        :external-menu-label="nav.menu[2]"
                      >
                      </collections-group>
                      <aside-links
                        v-if="isMobile"
                        class="col-12"
                        :external-menu-label="nav.menu[2]"
                        :preview-label="$t(nav.menu[2])"
                        :aside-list="nav.brand"
                      ></aside-links>
                    </div>
                  </div>
                </div>
              </transition>
            </li>
            <!-- Store Locator -->
            <li
              :aria-expanded="
                menuOpen && menuSection === 'store-locator' ? 'true' : 'false'
              "
            >
              <router-link
                :to="`${localizedUrl}/store-locator`"
                :aria-current="menuActive === 4"
                :tabindex="isMobile && !menuOpen ? -1 : 0"
                class="link -small"
                @click.native="callGTM({
                  event: 'menuClick',
                  menuLevel1: nav.menu[3],
                  menuLevel2: ''
                }), storeLocatorEvent({ siteLocation: 'Menu' })"
              >
                <p class="navigation-title h2" ref="menu4" v-text="$t(nav.menu[3])"></p>
              </router-link>
            </li>
            <!-- Services -->
            <li
              aria-haspopup="true"
              :aria-expanded="
                menuOpen && menuSection === 'services' ? 'true' : 'false'
              "
            >
              <button
                type="button"
                class="link -small"
                @click="toggleMenu('services'), callGTM({
                  event: 'menuClick',
                  menuLevel1: nav.menu[4],
                  menuLevel2: ''
                })"
                id="btn-menu-services"
                aria-controls="menu-services"
                :aria-current="menuActive === 5"
                :tabindex="isMobile && !menuOpen ? -1 : 0"
                :aria-expanded="
                  menuOpen && menuSection === 'services' ? 'true' : 'false'
                "
              >
                <p class="navigation-title h2" ref="menu5" v-text="$t(nav.menu[4])"></p>
                <span class="icon-arrow-right d-md-none" aria-hidden="true"></span>
              </button>
              <transition name="fade">
                <div
                  id="menu-services"
                  aria-labelledby="btn-menu-services"
                  class="menu_rich"
                  v-show="menuOpen && menuSection === 'services'"
                  :class="{ '-open': menuOpen && menuSection === 'services' }"
                >
                  <button
                    class="back d-flex d-md-none align-items-center"
                    type="button"
                    @click.stop.prevent="openMenu"
                  >
                    <undo-icon />
                    <span class="font-bold ml-4 pl-2" v-text="$t(nav.menu[4])"></span>
                  </button>
                  <div class="container">
                    <div class="row submenu-wrapper">
                      <aside-links
                        v-if="!isMobile"
                        class="col-lg-3"
                        :external-menu-label="nav.menu[4]"
                        :preview-label="$t(nav.menu[4])"
                        :aside-list="nav.services"
                      >
                        <MenuContactInfo :is-desktop-menu="true"></MenuContactInfo>
                      </aside-links>
                      <collections-group
                        class="col-12 col-lg-9"
                        :section-links="getSectionLinks('services')"
                        :collections-group="nav.services"
                        :is-server="isSSR"
                        :external-menu-label="nav.menu[4]"
                      >
                      </collections-group>
                      <aside-links
                        v-if="isMobile"
                        class="col-12"
                        :external-menu-label="nav.menu[4]"
                        :preview-label="$t(nav.menu[4])"
                        :aside-list="nav.services"
                      >
                        <MenuContactInfo></MenuContactInfo>
                      </aside-links>
                    </div>
                  </div>
                </div>
              </transition>
            </li>
            <!-- Wechat only China -->
            <li v-if="localizedUrl === '/zh_cn'">
              <button
                type="button"
                class="link -small -cn"
                @keyup.space="tooltipCn = true"
                aria-controls="modal-wechat"
                :aria-expanded="tooltipCn ? 'true' : 'false'"
                @click="tooltipCn = true"
                id="btn-menu-cn"
              >
                <p class="navigation-title h2" ref="menu6">
                  线上精品店
                </p>
              </button>
              <modal
                id="wechat"
                :is-open="tooltipCn"
                @close="
                  () => {
                    tooltipCn = false
                  }
                "
              >
                <div class="text-center">
                  <img src="/assets/img/tmp/qrcode-2.jpg" :alt="$t('WeChat')" />
                </div>
              </modal>
            </li>

            <template v-if="isMobile">
              <li class="header-phone-number--mobile">
                <a
                  v-if="phoneNumber"
                  :href="`tel:${phoneNumber}`"
                  class="link d-flex align-items-center"
                  @click="webToCallEvent({ method: 'phone', linkUrl: phoneNumber })"
                >
                  <contact-phone-icon />
                  <span class="header-phone-number-text ml-4 link-light -reverse">{{ phoneNumber }}</span>
                </a>
              </li>
              <li>
                <Lang
                  :currency="currentView.currency"
                  :lang="currentView.lang"
                  :menu-open="menuOpen"
                ></Lang>
              </li>
            </template>
          </ul>
        </nav>
        <ul v-if="!isMobile" class="utils col-auto">
          <li>
            <Lang
              :currency="currentView.currency"
              :lang="currentView.lang"
              :menu-open="menuOpen"
            ></Lang>
          </li>
          <li>
            <a
              v-if="phoneNumber"
              :href="`tel:${phoneNumber}`"
              class="utils-button header-phone-number-wrapper header-phone-number--desktop"
              @click="webToCallEvent({ method: 'phone', linkUrl: phoneNumber })"
            >
              <contact-phone-icon />
              <span class="header-phone-number-text a11y-sr-only">{{ phoneNumber }}</span>
            </a>
          </li>
          <li v-if="route !== 'search'">
            <button
              type="button"
              class="search utils-button px-0"
              @click="toggleSearch"
              :aria-label="$t('Search')"
              aria-haspopup="true"
              :aria-expanded="searchOpen ? 'true' : 'false'"
            >
              <SearchIcon />
            </button>
          </li>
          <li v-show="ecommerceActivated">
            <router-link
              :aria-label="$t('Shopping cart')"
              :to="`${localizedUrl}/cart`"
              class="utils-button"
            >
              <i class="icon-cart"></i>
            </router-link>
            <counter
              :value="itemsInCart"
              :active="itemsInCart"
              :trad="$t('Product in cart')"
            ></counter>
          </li>
          <li v-if="accountActivated || isQRStore">
            <router-link
              :aria-label="$t('My profile')"
              class="utils-button"
              :to="
                isLoggedIn
                  ? `${localizedUrl}/my-profile`
                  : `${localizedUrl}/login`
              "
            >
              <i class="icon-account"></i>
            </router-link>
            <LoginTooltip :menu-open="menuOpen" />
          </li>
        </ul>
      </div>
      <!-- Toolbar to inform user of action -->
      <Feedback v-if="show" show="false"></Feedback>
    </header>
  </div>
</template>

<script>
import Counter from './Counter'
import Search from './Search'
import { getRouteName, DISABLED_URLS_STORES, storeLocatorEvent } from '../utilities'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { mapGetters, mapActions } from 'vuex'
import { ReadyHook } from 'vue-asyncready'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import { isServer } from '@vue-storefront/core/helpers'
import TopMessage from 'src/themes/zenith/components/TopMessage'
import GeoPopup from 'src/themes/zenith/components/GeoPopup'
import Burger from 'src/themes/zenith/components/Burger'
import ContactPhoneIcon from './header/ContactPhoneIcon'
import LoginTooltip from './header/LoginTooltip.vue'
import { webToCallEvent } from '../utilities/trackEvent'
import SearchIcon from './icons/SearchIcon.vue'
import UndoIcon from './icons/UndoIcon.vue'
import CollectionsGroup from './header/CollectionsGroup.vue'
import AsideLinks from './header/AsideLinks.vue'
import MenuContactInfo from './header/MenuContactInfo.vue'

let headerHeight
let elVirtualContainer

export default {
  name: 'Header',
  mixins: [ReadyHook],
  components: {
    Counter,
    // NoSSR,
    Search,
    TopMessage,
    Burger,
    ContactPhoneIcon,
    LoginTooltip,
    Lang: () => import(/* webpackChunkName: "lang-header-cpt" */ './Lang'),
    Feedback: () =>
      import(/* webpackChunkName: "editorial-header-cpt" */ './utils/Feedback'),
    Modal: () =>
      import(/* webpackChunkName: "modal-header-cpt" */ './utils/Modal'),
    SearchIcon,
    UndoIcon,
    CollectionsGroup,
    AsideLinks,
    MenuContactInfo,
    GeoPopup
  },
  data() {
    return {
      currentHeaderHeight: 95,
      isSSR: true,
      ecommerceActivated: null,
      menuHover: null,
      menuRich: null,
      scrollDirection: 'top',
      menuShow: false,
      searchActive: false,
      lastScrollPos: 0,
      menuThrottle: null,
      currentTranslateHeader: 0,
      tooltipCn: false,
      dir: '',
      lang: 'English',
      currency: 'USD',
      links: [],
      focused: 0,
      isVScroll: false,
      nav: {
        menu: [
          'New models',
          'Watches',
          'The brand',
          'Stores',
          'Services',
          'Straps'
        ],
        anniversary: {
          link: '/brand/160th-anniversary'
        },
        watches: {
          previewLabel: 'The Zenith Collections',
          cta: 'See all zenith watches',
          ctaLink: 'products/watches',
          linkLabel: 'See the Collection',
          collections: [
            {
              title: 'Defy',
              subtitle: 'Innovation and accuracy',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/watches/skyline.png',
                  'image',
                  'static'
                ),
                alt: 'Defy',
                width: 100,
                height: 154
              },
              link: '/products/defy'
            },
            {
              title: 'Chronomaster',
              subtitle: 'Iconic and timeless',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/watches/cms.png',
                  'image',
                  'static'
                ),
                alt: 'Chronomaster',
                width: 100,
                height: 154
              },
              link: '/products/chronomaster'
            },
            {
              title: 'G.F.J',
              subtitle: 'Certified Vintage',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/watches/gfj.png',
                  'image',
                  'static'
                ),
                alt: 'gfj',
                width: 100,
                height: 154
              },
              link: '/products/gfj'
            },
            {
              title: 'Pilot',
              subtitle: 'Reliability and impact',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/watches/pilot.png',
                  'image',
                  'static'
                ),
                alt: 'Pilot',
                width: 100,
                height: 154
              },
              link: '/products/pilot'
            }
          ],
          selections: {
            title: 'Our selection',
            items: [
              {
                title: 'Chronomaster Sport',
                link: 'brand/chronomaster-sport'
              },
              {
                title: 'Defy Skyline',
                link: 'defy-skyline'
              },
              {
                title: 'Defy Diver',
                link: 'brand/defy-diver'
              },
              {
                title: 'Icons',
                link: 'products/icons'
              },
              {
                title: 'Zenith | USM',
                link: 'brand/zenith_usm'
              }
            ]
          },
          limited: {
            title: 'Limited Editions',
            img: ImageManager.convert(
              '/assets/img/tmp/nav_limited.jpg',
              'image',
              'static'
            ),
            link:
              'product/chronomaster-revival-a3818-cover-girl-03-a3818-400-51-m3818',
            width: 300,
            height: 168
          }
        },
        straps: {
          title: 'In oculis quidem',
          text:
            'A change of straps can go a long way in giving your Zenith watch a personalized touch. With Zenith’s quick strap-change system, a new look is just a few clicks away.',
          cta: {
            title: 'Magna carta straps',
            link: 'products/straps',
            image: {
              url: ImageManager.convert(
                '/assets/img/tmp/nav_limited.jpg',
                'image',
                'static'
              ),
              alt: 'Straps',
              width: 100,
              height: 154
            }
          }
        },
        brand: {
          linkLabel: 'Find out more',
          collections: [
            {
              title: 'History',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/history.png',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'History',
                width: 100,
                height: 154
              },
              link: '/brand/timeline'
            },
            {
              title: 'Partnerships',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/partnerships.png',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Partnerships',
                width: 100,
                height: 154
              },
              link: '/brand/partnerships'
            },
            // { WILL BE RESTORED IN THE FUTURE
            //   title: 'Savoir-Faire',
            //   image: {
            //     url: ImageManager.convert(
            //       '/assets/img/nav/savoir-faire.png',
            //       'image',
            //       'static'
            //     ),
            //     filter: '',
            //     alt: 'Savoir-faire',
            //     width: 100,
            //     height: 154
            //   },
            //   link: '/brand/savoir-faire'
            // },
            {
              title: 'Calibre',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/calibres.png',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Calibre',
                width: 100,
                height: 154
              },
              link: '/brand/sound-of-precision'
            },
            {
              title: 'Commitments',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/commitments.png',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'commitments',
                width: 100,
                height: 154
              },
              link: '/brand/commitments'
            }
          ],
          selections: {
            items: [
              // {
              //   title: 'WATCH CLINIC',
              //   link: 'brand/watch-clinic'
              // }
            ]
          }
        },
        services: {
          linkLabel: 'Find out more',
          collections: [
            {
              title: 'Maintenance and restoration',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/savoir-faire.png',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Maintenance and restoration',
                width: 100,
                height: 154
              },
              link: '/service/maintenance-and-services',
              clickCallback: () => {
                this.$gtm.trackEvent({
                  event: 'repair_journey_touch_point',
                  ctaName: 'Maintenance and restoration',
                  siteLocation: 'Header Menu'
                })
              }
            },
            {
              title: 'Send us your watch',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/service_return.jpg',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Send us your watch',
                width: 100,
                height: 154
              },
              link: '/service/return-your-watch-to-manufacture',
              clickCallback: () => {
                this.$gtm.trackEvent({
                  event: 'repair_journey_touch_point',
                  ctaName: 'Send us your watch',
                  siteLocation: 'Header Menu'
                })
              }
            },
            {
              title: 'Extend your warranty',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/service_register.jpg',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Extend your warranty',
                width: 100,
                height: 154
              },
              link: this.isLoggedIn ? '/register' : '/login?register',
              clickCallback: () => {
                this.$gtm.trackEvent({
                  event: 'repair_journey_touch_point',
                  ctaName: 'Extend your warranty',
                  siteLocation: 'Header Menu'
                })
              }
            },
            {
              title: 'Extracts and certificates',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/service_extracts.jpg',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Extracts and certificates',
                width: 100,
                height: 154
              },
              link: '/service/extracts-certificates',
              clickCallback: () => {
                this.$gtm.trackEvent({
                  event: 'repair_journey_touch_point',
                  ctaName: 'Extracts and certificates',
                  siteLocation: 'Header Menu'
                })
              }
            }/*,
            {
              title: 'Care',
              image: {
                url: ImageManager.convert(
                  '/assets/img/nav/service_maintenance.jpg',
                  'image',
                  'static'
                ),
                filter: '',
                alt: 'Care',
                width: 100,
                height: 154
              },
              link: '/care'
            } */
          ],
          selections: {
            items: [
              {
                title: 'International warranty',
                link: 'service/international-warranty'
              },
              {
                title: 'Catalogue',
                link: 'service/catalogue'
              },
              {
                title: 'User manuals',
                link: 'page/user-manuals'
              },
              {
                title: 'Contact us',
                link: 'service/contact-customer-care'
              }
            ]
          }
        }
      },
      scrollHeaderPageTypes: [
        'Product page'
      ],
      currentUnderlinedSelector: null
    }
  },
  beforeMount() {
    this.$bus.$on('header-fixed', () => {
      this.menuShow = true
    })
    this.$bus.$on('vscroll-created', () => {
      this.onVScrollCreated()
    })
    this.$bus.$on('vscroll-destroyed', () => {
      this.onVScrollDestroyed()
    })
  },
  mounted() {
    this.isSSR = isServer
    // this.onScrollWindow(0)

    this.setMobile(window.innerWidth < 768)
    this.adjustHeaderPosition()
    this.setDynamicWindowHeight()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
    document.addEventListener('keyup', this.keyup)
    document.addEventListener('keydown', this.keydown)
  },
  watch: {
    isMenuSectionOpened() {
      this.$nextTick(() => {
        this.adjustHeaderPosition()
        if (!this.isMenuSectionOpened) {
          this.setActiveMenuUnderline(null)
        }
        this.$store.dispatch('zenith-ui/setBodyOverflow')
      })
    },
    menuSection() {
      this.$nextTick(() => {
        if (this.menuSection && this.menuSection !== 'lang' && this.menuOpen) {
          this.setActiveMenuUnderline('#btn-menu-' + this.menuSection)
        }
      })
    },
    searchOpen() {
      this.$nextTick(() => {
        if (this.searchOpen) {
          this.setActiveMenuUnderline('.search.utils-button')
        }
      })
    },
    langOpen() {
      this.$nextTick(() => {
        if (this.langOpen) {
          this.setActiveMenuUnderline('#btn-lang')
        }
      })
    },
    $route() {
      this.$refs.headerWrapper.classList.remove('-scroll-down')
    }
  },
  computed: {
    ...mapGetters('feedback', ['show']),
    headerTranslateY() {
      if (this.menuOpen) {
        return '0'
      }

      if (this.scrollDirection !== 'top') {
        if (this.$refs.topMessage) {
          const topMessageHeight = this.$refs.topMessage.$el.clientHeight
          const offset = parseInt(topMessageHeight) + 2
          return '-' + offset
        }
      }

      return '0'
    },
    logoUrl() {
      return this.getLogoUrl(this.isMenuSectionOpened)
    },
    logo160Url() {
      return this.getLogo160Url(this.isMenuSectionOpened)
    },
    isLogo160Online() {
      return this.getIsLogo160Online()
    },
    phoneNumber() {
      return currentStoreView().contactPhone
    },
    isHeaderTransparent() {
      const route = getRouteName(this.$route.name)

      return (
        route === 'home' || route === 'collections' || route === 'news-list'
      )
    },
    isHeaderBackgroundTransparent() {
      return this.isHeaderTransparent && this.scrollDirection !== 'down' && !this.isMenuSectionOpened
    },
    isMobile() {
      return this.$store.state['zenith-ui'].menu.mobile
    },
    menuOpen() {
      return this.$store.state['zenith-ui'].menu.open
    },
    isMenuSectionOpened() {
      return this.menuOpen || this.searchOpen || this.langOpen
    },
    langOpen() {
      return this.$store.state['zenith-ui'].lang.open
    },
    menuSection() {
      return this.$store.state['zenith-ui'].menu.section
    },
    searchOpen() {
      return this.$store.state['zenith-ui'].search.open
    },
    strapActivated() {
      const { isStrapActivated } = currentStoreView()
      return isStrapActivated
    },
    currentView() {
      const { i18n } = currentStoreView()
      const { fullLanguageName, currencyCode } = i18n
      return {
        lang: fullLanguageName,
        currency: currencyCode
      }
    },
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('cart', ['getItemsTotalQuantity']),
    ...mapGetters('prismic', ['getPage']),
    itemsInCart() {
      return this.getItemsTotalQuantity
    },
    accountActivated() {
      const { account } = currentStoreView()
      return account !== false
    },
    isQRStore() {
      const { isQRStore } = currentStoreView()
      return isQRStore === true
    },
    localizedUrl() {
      return currentStoreView().url || ''
    },
    route() {
      return getRouteName(this.$route.name)
    },
    menuActive() {
      switch (this.route) {
        case 'selection':
          return 1
        case 'collections':
          return 2
        case 'brand':
          return 3
        case 'store-locator':
          return 4
        case 'service':
          return 5
        case 'straps':
          return 6
        default:
          return null
      }
    },
    limitedEditionPicture() {
      return {
        url: this.nav.watches.limited.img,
        lowDefinitionUrl: ImageManager.getLowDefinition(
          this.nav.watches.limited.img,
          40,
          0.5614035088
        ),
        srcset: ImageManager.getSrcSet(
          this.nav.watches.limited.img,
          600,
          100,
          50,
          0.5614035088
        ),
        alt: this.nav.watches.limited.title,
        width: 285,
        height: 160
      }
    },
    limitedEditionPictureSizes() {
      return '(max-width: 992px) 21vw, (max-width: 1600px) 16vw, 42vw'
    },
    bannerStrapPicture() {
      return {
        url: this.nav.straps.cta.image.url,
        lowDefinitionUrl: ImageManager.getLowDefinition(
          this.nav.straps.cta.image.url,
          790,
          0.30379747
        ),
        srcset: ImageManager.getSrcSet(
          this.nav.straps.cta.image.url,
          600,
          100,
          50,
          0.30379747
        ),
        alt: this.nav.straps.cta.image.alt,
        width: 790,
        height: 240
      }
    },
    bannerStrapPictureSizes() {
      return '(max-width: 992px) 100vw, (max-width: 1600px) 100vw, 50vw'
    }
  },
  methods: {
    ...mapActions('zenith-ui', ['isEcommerce']),
    ...mapActions('prismic', ['setPage']),
    storeLocatorEvent,
    setActiveMenuUnderline(selector) {
      if (window && window.innerWidth >= 992 && this.$el && this.isMenuSectionOpened) {
        selector = selector || 'button[aria-expanded="true"]'
        this.currentUnderlinedSelector = selector
        const navigationRowLeft = this.$refs?.navigationRow?.getBoundingClientRect().left
        const buttonRect = this.$el.querySelector(selector)?.getBoundingClientRect()
        if (buttonRect) {
          this.$el.style.setProperty('--active-selector-left', (buttonRect.left - navigationRowLeft || 0) + 'px')
          this.$el.style.setProperty('--active-selector-width', (buttonRect.width) + 'px')
        }
      } else {
        this.currentUnderlinedSelector = null
        this.$el.style.setProperty('--active-selector-left', '0px')
        this.$el.style.setProperty('--active-selector-width', '0px')
      }
    },
    adjustHeaderPosition() {
      this.currentHeaderHeight = this.$el ? Math.floor(this.$el.offsetHeight) : this.currentHeaderHeight
    },
    callGTM(gtmObject) {
      if (gtmObject && gtmObject.event) {
        this.$gtm.trackEvent(gtmObject)
      }
    },
    getSectionLinks(sectionName) {
      const storeCode = currentStoreView().storeCode
      if (DISABLED_URLS_STORES.hasOwnProperty(storeCode)) {
        return this.nav[sectionName].collections.filter(
          collection => !DISABLED_URLS_STORES[storeCode].includes(collection.link)
        )
      }
      if (this.nav[sectionName]) {
        return this.nav[sectionName].collections
      }
      return []
    },
    keydown(e) {
      // For AA compliant Keyboard navigation
      if ((e.keyCode === 37 || e.keyCode === 38) && this.menuOpen) {
        e.preventDefault()
        this.focused =
          this.focused - 1 < 0 ? this.links.length - 1 : this.focused - 1
        this.links[this.focused].focus()
      }
      if ((e.keyCode === 39 || e.keyCode === 40) && this.menuOpen) {
        e.preventDefault()
        this.focused =
          this.focused + 1 >= this.links.length ? 0 : this.focused + 1
        this.links[this.focused].focus()
      }
    },
    keyup(e) {
      if (e.keyCode === 27) {
        this.closeMenu()
        if (this.isMobile) {
          document.querySelector('.burger').focus()
        }
      }
    },
    clickOutside(e) {
      this.closeSearch()
    },
    onResize(e) {
      this.setMobile(window.innerWidth < 768)
      this.$store.dispatch('zenith-ui/setBodyOverflow')
      this.setDynamicWindowHeight()
      this.adjustHeaderPosition()
      if (this.currentUnderlinedSelector) {
        this.setActiveMenuUnderline(this.currentUnderlinedSelector)
      }
    },
    onScroll() {
      this.handleScroll()
    },
    closeSearch() {
      if (this.searchOpen) {
        this.$store.dispatch('zenith-ui/closeSearch')
      }
    },
    toggleMenu(item) {
      const menu = this.$store.state['zenith-ui'].menu
      if (menu.open && menu.section === item) {
        this.closeMenu()
      } else {
        this.$store.commit('zenith-ui/setMenu', {
          open: true,
          section: item
        })
      }
    },
    openMenu(item = null) {
      clearTimeout(this.menuThrottle)
      this.menuThrottle = setTimeout(() => {
        this.$store.commit('zenith-ui/setMenu', {
          open: true,
          section: item
        })
        clearTimeout(this.menuThrottle)
      }, 200)
    },
    closeMenu(e) {
      if (!this.isMobile || (this.isMobile && e.type !== 'mouseleave')) {
        clearTimeout(this.menuThrottle)
        this.menuThrottle = setTimeout(() => {
          this.$store.dispatch('zenith-ui/closeMenu')
          clearTimeout(this.menuThrottle)
        }, 200)
      }
    },
    setMobile(mobile) {
      this.$store.commit('zenith-ui/setMobile', mobile)
    },
    setDynamicWindowHeight() {
      document.documentElement.style.setProperty('--100dvh', `${window.innerHeight}px`)
    },
    toggleSearch() {
      this.$store.commit('zenith-ui/setMenu', {
        open: false,
        section: null
      })
      this.$store.commit('zenith-ui/setSearch', !this.searchOpen)
    },
    leaveMenuMobile() {
      if (this.isMobile) {
        this.closeMenu()
      }
    },
    handleScroll() {
      if (this.isMobile && this.isMenuSectionOpened) return
      const scrollY = window.scrollY
      const scrollDownOffset = this.lastScrollPos + 40
      const scrollUpOffset = this.isMobile
        ? this.lastScrollPos - 20
        : this.lastScrollPos - 40
      const pageType = this.$route && this.$route.meta && this.$route.meta.pageType
      if (this.scrollHeaderPageTypes.includes(pageType)) {
        if (scrollY < 5) {
          this.scrollDirection = 'top'
        } else if (scrollY >= scrollDownOffset) {
          this.scrollDirection = 'down'
        } else if (scrollY < scrollUpOffset) {
          this.scrollDirection = 'up'
        }
        this.$store.state['zenith-ui'].menu.isHeaderVisible = this.scrollDirection !== 'down'
        this.lastScrollPos = scrollY
      }
    },
    // Utils for Chronomaster Landing (pages/CollectionLanding.vue)
    onVScrollCreated() {
      if (window.vscroll) {
        this.isVScroll = true
        headerHeight = document.querySelector('.top-msg')
          ? document.querySelector('.top-msg').clientHeight +
            this.$el.clientHeight
          : this.$el.clientHeight
        this.currentTranslateHeader = headerHeight
        elVirtualContainer = document.querySelector('.chrono-container')
        elVirtualContainer.style.transform = `translateY(${this.currentTranslateHeader}px)`
        // elVirtualContainer.style.height = `${window.innerHeight - this.currentTranslateHeader}px`
        // elVirtualContainer.style.transition = 'none'
        if (this.$refs.header) {
          this.$refs.header.style.transform = `translateY(${this.currentTranslateHeader}px)`
        }
        this.$refs.header.style.transition = 'transform 0.3s ease-out'
        elVirtualContainer.style.transition = 'transform 0.3s ease-out'
        window.vscroll.on('scroll', this.onVirtualScroll)
      }
    },
    onVScrollDestroyed() {
      if (this.$refs.header) {
        this.$refs.header.style.removeProperty('transform')
      }
    },
    onVirtualScroll(objScroll) {
      const direction = objScroll.direction
      let scrollY = objScroll.scroll.y
      let scrollHeader = headerHeight - scrollY

      if (scrollY > headerHeight) {
        // elVirtualContainer.style.transition = 'transform 0.2s ease-in-out, height 0.2s ease-in-out'
        scrollHeader = 0
        if (direction === 'up') {
          scrollHeader = headerHeight
        }
      } else {
        // elVirtualContainer.style.transition = 'none'
        if (direction === 'up') {
          if (this.currentTranslateHeader >= headerHeight) {
            scrollHeader = headerHeight
          }
        }
      }

      if (this.currentTranslateHeader !== scrollHeader) {
        this.currentTranslateHeader = scrollHeader
        elVirtualContainer.style.transform = `translateY(${this.currentTranslateHeader}px)`
        // elVirtualContainer.style.height = `${window.innerHeight - this.currentTranslateHeader}px`
        if (this.$refs.header) {
          this.$refs.header.style.transform = `translateY(${this.currentTranslateHeader}px)`
        }
      }
    },
    getLogoUrl(isMenuOpen = false) {
      const logo = isMenuOpen && this.$store.state['zenith-ui'].logo.urlOnBlueMenu
        ? this.$store.state['zenith-ui'].logo.urlOnBlueMenu
        : this.$store.state['zenith-ui'].logo.url
      const fallback = '/assets/img/logo_black.svg'

      return logo || fallback
    },
    getLogo160Url(isMenuOpen) {
      // inside GlobalSettings.ts is handled onTransparentUrl fallback to baseUrl if it is empty
      const logo = isMenuOpen && this.$store.state['zenith-ui'].logo_160.urlOnBlueMenu ? this.$store.state['zenith-ui'].logo_160.urlOnBlueMenu : this.$store.state['zenith-ui'].logo_160.baseUrl
      const fallback = '/assets/img/logo_160_blue.png'
      return logo || fallback
    },
    getIsLogo160Online() {
      return this.$store.state['zenith-ui'].logo_160.isVisible
    },
    // END Utils for Chronomaster Landing
    webToCallEvent
  },
  created() {
    // this.$nextTick(() => {
    //   this.ecommerceActivated = this.$store.state['zenith-ui'].ecommerce
    // })
    this.isEcommerce().then(result => (this.ecommerceActivated = result))
  },
  destroyed: function() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.onScroll)
    document.removeEventListener('keyup', this.keyup)
    document.removeEventListener('keydown', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.header-wrapper {
  --_zenith-header-background: var(--zenith-header-background);
  --_zenith-color-transparent: var(--zenith-theme-primary-transparent);
  --_zenith-header-text-link: var(--zenith-theme-primary);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  transition: all 0.2s ease-in-out;
  background: var(--_zenith-header-background);

  &.-scroll-down {
    transform: translateY(-100%);
  }

  &.-menu-section-open {
    --_zenith-header-background: var(--zenith-header-open-background);
    --_zenith-color-transparent: var(--zenith-white-transparent);
    --_zenith-header-text-link: var(--zenith-white);
  }

  &.-menu-open {
    @include bp(max md) {
      .geopopup,
      .top-message {
        display: none;
      }
    }

    .header-background {
      position: fixed;
      z-index: var(--background-z-index);
      inset: 0;

      @include bp(max md) {
        display: none;
      }
    }
  }
}

.header {
  position: relative;
  width: 100%;
  --background-z-index: 1;
  --content-z-index: 2;

  @include bp(xl) {
    padding-inline: 6rem;
    max-width: 164rem;
  }

  > .row {
    z-index: var(--content-z-index);
    position: relative;
    padding-bottom: 1.5rem;

    &::before,
    &::after {
      content: '';
      display: block;
      height: 0.1rem;
      position: absolute;
      bottom: 0;
      // to go over language selector
      z-index: 101;
    }

    &::before {
      background-color: var(--_zenith-header-text-link);
      width: var(--active-selector-width, 0);
      left: var(--active-selector-left, 0);
      transition: all 0.3s ease-in-out;
    }

    &::after {
      width: 100%;
      left: 0;
      background-color: var(--_zenith-color-transparent);
    }

    &:not(:is(.-menu-section-open .row))::after {
      background-color: transparent;
    }
  }

  @include bp(max md) {
    transition: height 0s 0.4s;
    padding-inline: 3rem;

    & > .row {
      height: 100%;
      transition: height 0s 0.4s, padding 0s 0.4s;
      .search,
      .menu {
        opacity: 0;
        display: none;
        pointer-events: none;
        transition: all 0.2s ease-in-out;
      }

      nav {
        padding-inline: 0;

        &:is(.-open nav) {
          @include bp(max md) {
            &,
            .submenu-wrapper {
              overflow-y: auto;
              max-height: calc(var(--100dvh, 100vh) - 16rem);
              min-height: 15rem;
            }

            &:has(.menu_rich.-open, #btn-lang[aria-expanded="true"]) {
              overflow-y: hidden;
            }
          }
        }
      }
    }
  }

  &.-open {
    @include bp(max md) {
      background: var(--_zenith-header-background);

      &:after {
        opacity: 0;
      }

      & > .row {
        display: flex;
        height: var(--100dvh, 100vh);
        background: var(--_zenith-header-background);
        transition: background 0.2s ease-in-out;

        .search,
        .menu {
          opacity: 1;
          pointer-events: all;
          display: flex;

          > li {
            width: 100%;
          }
        }
        .search {
          display: block;
        }
      }
    }
  }

  .logo {
    display: inline-block;
    position: relative;
    z-index: 10;

    h1 {
      margin: 0;
      line-height: 0;
    }

    img {
      width: 13.3rem;
      height: 5rem;
      object-fit: contain;

      @include bp(max md) {
        height: 4rem;
        width: 10.7rem;
      }
      @media (prefers-color-scheme: dark) {
        filter: var(--zenith-img-color-invert);
      }
    }
    &.fade-enter-active,
    &.fade-leave-active {
      transition: all 0.2s ease-in-out;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
      position: absolute;
    }
  }

  .utils {
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;
    transition: opacity 0.2s ease-in-out;

    @include bp(max md) {
      padding: 0;
    }

    @include bp(md lg) {
      margin: 1rem auto;
    }

    li {
      position: relative;

      i {
        font-size: 2rem;
      }

      &:not(:last-child) {
        padding-inline: 0 2rem;

        @include bp(max md) {
          padding-inline: 0 1.5rem;
        }
      }

      @include bp(md) {
        &:nth-child(2) {
          border-right: 0.1rem solid var(--_zenith-color-transparent);
          margin-right: 2rem;
        }
      }
    }

    /deep/ .utils-button {
      position: relative;
      display: block;
      color: var(--_zenith-header-text-link);
      border: none;
      background: none;

      i {
        display: block;
      }

      &:after {
        display: block;
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        height: 0.1rem;
        width: 0;
        opacity: 0;
        background: var(--_zenith-header-text-link);
        transform: translateX(-50%);
        transition: $transition-default-fast;
      }

      &:hover,
      &:focus,
      &:active,
      &.-active {
        &:after {
          opacity: 1;
          width: 100%;
        }
      }
    }

    .counter {
      position: absolute;
      top: 0;
      right: 1.7rem;

      @include bp(max md) {
        right: 1.2rem;
      }
    }
  }

  .menu {
    display: flex;
    align-items: center;
    column-gap: 3rem;
    padding: 0;
    margin: 0 auto;
    list-style: none;

    .submenu-wrapper {
      padding-block: 0;

      @include bp(md) {
        padding-block: 6rem 10rem;
      }
    }

    @include bp(max md) {
      width: 100%;
      padding: 0;
      flex-direction: column;
    }

    li {
      .link {
        position: relative;
        z-index: 40;
        display: block;
        width: 100%;
        padding: 0;
        color: var(--_zenith-header-text-link);
        text-transform: uppercase;
        text-align: center;
        border: none;
        background: none;
        outline: none;

        &,
        a,
        button {
          transition: none;
        }

        a {
          color: inherit;
        }

        &.link-160 {
          @include bp(md) {
            padding: 0;
          }

          .img-160 {
            width: auto;
            max-height: 5.3rem;
            object-fit: cover;
          }
        }

        @include bp(max md) {
          text-align: left;
          font-size: 1.8rem;
          font-weight: 300;
          line-height: 1.2;
          padding-block: 2.5rem;
          border-top: 0.1rem solid var(--_zenith-color-transparent);

          &:focus {
            outline: 1px dashed #383838;
            outline-offset: 4px;
          }
        }

        .navigation-title {
          margin: 0;
          display: inline;
          pointer-events: none;
          font-size: inherit;
          font-weight: inherit;
        }
      }

      @include bp(max md) {
        button.link {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .icon-arrow-right {
            --_icon-size: 1.2rem;
            display: inline-block;
            margin-right: 0.9rem;
            transform: rotate(-45deg);
            width: var(--_icon-size);
            height: var(--_icon-size);
            border: solid var(--_zenith-header-text-link);
            border-width: 0 0.15rem 0.15rem 0;
          }
        }
      }

      &:first-child .link {
        @include bp(max md) {
          border-top: none;
        }
      }
    }

    &_selector {
      position: absolute;
      z-index: 10;
      bottom: 0;
      height: 0.2rem;
      opacity: 0;
      background: var(--_zenith-header-text-link);
      pointer-events: none;
      transition: all 0.2s ease-in-out;

      &.-active,
      &.-focus {
        opacity: 1;
      }

      @include bp(max md) {
        display: none;
      }
    }

    &_rich {
      position: fixed;
      z-index: 20;
      top: var(--zenith-header-height, 9.5rem);
      left: 0;
      width: 100%;
      background: var(--_zenith-header-background);

      @include bp(max md) {
        top: 8.5rem;
        left: 0;
        z-index: 50;
        overflow: hidden;
        transition: all 0.4s ease-in-out;

        .container {
          overflow-y: auto;
        }
      }

      .container.-straps {
        padding-top: 6rem;
        padding-bottom: 6rem;

        .aside.straps {
          padding-top: 0;
          padding-bottom: 0;
          align-items: center;
          justify-content: center;
          display: flex;
          flex-direction: column;
          transition: all 0.4s 0.2s ease-in-out;

          &:before {
            display: none;
          }
        }

        .banner {
          display: block;
          overflow: hidden;
          position: relative;
          border-radius: 0.4rem;
          padding-top: 30%;
          width: 100%;
          height: 0;
          transition: all 0.4s ease-in-out;

          &:after {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.6) 100%
            );
          }

          strong {
            position: absolute;
            z-index: 10;
            bottom: 2rem;
            display: block;
            color: var(--zenith-white);
            width: 100%;
            text-align: center;
            font-size: em(14);
            font-weight: bold;
            letter-spacing: em(2, 14);
            line-height: em(19, 14);
            text-transform: uppercase;
          }

          /deep/ .obs {
            position: absolute;
            top: 50%;
            left: 50%;
            object-fit: cover;
            width: 100%;
            height: 100%;
            transform: translate(-50%, -50%);

            img {
              position: absolute;
              top: 50%;
              left: 50%;
              object-fit: cover;
              width: 100%;
              height: 100%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }

      .back {
        position: relative;
        text-align: start;
        width: calc(100% - 3rem);
        border: none;
        background: var(--_zenith-header-background);
        text-transform: uppercase;
        padding-block: 1.5rem;
        margin-inline: 1.5rem;
        border-block: 1px solid var(--_zenith-color-transparent);
        color: var(--_zenith-header-text-link);

        @include bp(lg) {
          display: none;
        }
      }

      &.fade-leave-active {
        .collections,
        .straps,
        .banner,
        .btn,
        .selection,
        .limited {
          @include bp(lg) {
            transition: all 0.4s ease-in-out;
          }
        }
      }

      &.fade-enter,
      &.fade-leave-to {
        .collections,
        .straps,
        .banner,
        .btn,
        .selection,
        .limited {
          @include bp(lg) {
            opacity: 0;
            transform: translateY(-2rem);
          }
        }

        @include bp(max md) {
          left: 100%;
        }
      }
    }

    .limited {
      position: relative;
      transition: all 0.4s 0.3s ease-in-out;

      @include bp(max md) {
        padding: 0;
        margin-bottom: 8rem;
      }

      @include bp(lg) {
        padding-top: 3rem;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 1rem;
          right: 0;
          height: 0.1rem;
          background: var(--zenith-header-border);
        }
      }

      a {
        position: relative;
        display: block;
        overflow: hidden;
        border-radius: 0.4rem;

        @include bp(max md) {
          margin: 0 1.5rem;
        }
        /deep/ .limited-edition-image {
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1);
          }
          &:before {
            display: block;
            content: '';
            position: absolute;
            z-index: 5;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(var(--zenith-theme-primary), 0.2);
            transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1);
          }
        }

        &:hover /deep/ .limited-edition-image,
        &:focus /deep/ .limited-edition-image {
          &:before {
            opacity: 0;
          }

          img {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
[data-user-color-scheme='dark'] {
  .header .logo img {
    filter: var(--zenith-img-color-invert);
  }
}

.header .menu li.header-phone-number--mobile .link {
  border-bottom: none;
  padding-top: 5rem;
}

.header-phone-number {
  &--mobile {
    position: relative;
    z-index: 40;

    /deep/ .icon {
      width: 2.4rem;
      height: 2.4rem;
    }

    .link-light {
      color: var(--_zenith-header-text-link);
      &::before {
        background: var(--_zenith-header-text-link);
      }
    }

    &:hover {
      .link-light::before{
        width: 100%;
      }
    }

    @include bp(md) {
      display: none;
    }
  }

  &-wrapper {
    border: none;
    background: none;
    font-size: 0.64286em;
    outline: none;
    color: var(--_zenith-header-text-link);

    @include bp(max md) {
      display: flex;
      align-items: center;

      &.header-phone-number--desktop {
        display: none;
      }
    }
  }

  &-text {
    position: relative;
    color: inherit;
    text-decoration: none;
    font-size: 1.4rem;
    font-weight: 300;
    line-height: 1.2;
  }
}
</style>
